import styled from "styled-components";
import { Box } from "@mui/material";

export const CMHeadingContainer = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",
  fontWeight: 500,
  fontSize: 16,

  "& h3": {
    margin: 0,
    paddingRight: 25,
    paddingLeft: 18,
    fontFamily: props.theme.fontFamilies.workSans,
    [`@media (min-width: 2000px)`]: {
      fontSize: "3vh",
      marginLeft: "2vh"
    },
  },
  "& h3 span": {
    color: "#A80000",
  },

  [`@media${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
  },

  [`@media${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
  },
}));
export const CMDetails = styled.div((props) => ({
  display: "flex",
  position: "relative",
  marginTop: props.theme.spacers["1"],
  marginLeft: 18,
  h1: {
    margin: 0,
  },

  [`@media (min-width: 2000px)`]: {
    marginLeft: "2vh",
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    flexDirection: "row",
    textAlign: "center",

    "& > div": {
      width: "100%",
    },
  },
}));
export const CMCarouselContainer = styled.div((props) => ({
  width: "12%",
  paddingTop: 0,
  "& .swiper": {
    paddingBottom: "10%",
  },

  "& img": {
    width: 59,
    height: 59,
    [`@media (min-width: 2000px)`]: {
      width: "15vh",
      height: "auto",
    },
  },
  [`@media (min-width: 2000px)`]: {
    width: "auto",
    height: "auto"
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    width: "35% !important",
    maxWidth: "200px",
  },
}));
export const CMAuctionDescription = styled.div((props) => ({
  paddingTop: "2%",
  paddingLeft: "2%",
  paddingBottom: 17,
  alignContent: "center",
  [`@media (min-width: 2000px)`]: {
      flex:1,
    },
  "& h5": {
    fontFamily: props.theme.fontFamilies.jost,
    fontWeight: "normal",
    [`@media (min-width: 2000px)`]: {
      fontSize: "2vh",
    },
  },
  "& h3": {
    fontSize: props.theme.fontSizes.h2,
    fontFamily: props.theme.fontFamilies.workSans,
    [`@media (min-width: 2000px)`]: {
      fontSize: "3vh",
    },
  },

  [`${CMCardContainer}`]: {
    display: "none",
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    textAlign: "left",
    paddingTop: "3%",
    [`${CMCardContainer}`]: {
      width: "100%",
      display: "block",
      position: "unset",
      marginTop: props.theme.spacers["5"],
      marginBottom: props.theme.spacers["2"],

      "& > div > div": {
        width: "95%",
      },
    },
  },
}));
export const CMCardContainer = styled.div`
  width: 40%;
  position: absolute;
  right: 0;
  max-width: 453px;

  @media ${(props) => props.theme.breakpoints.lg} {
    display: none;
    max-width: 640px;
  }
`;
export const CMBox = styled(Box)((props) => ({
  textAlign: "left",
  backgroundColor: " #F3FAFC",
  borderRadius: 33,
  height: 188,
  marginTop: 30,
  fontFamily: props.theme.fontFamilies.jost,
  fontWeight: "normal",



  "& .table-container": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    paddingTop: "22px",
    "& h5": {
      fontFamily: props.theme.fontFamilies.jost,
      fontWeight: "normal",
      [`@media (min-width: 2000px)`]: {
        fontSize: "3vh",
      },
    },

    "& div": {
      marginBottom: "20px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      textAlign: "center",
      height: 125,
      [`@media (min-width: 2000px)`]: {
        fontSize: "2vh",
        height: "auto",
      },
    },
    "& h3": {
      justifyContent: "center",
      fontFamily: props.theme.fontFamilies.jost,
      fontWeight: "normal",
      [`@media (min-width: 2000px)`]: {
        fontSize: "2vh",
      },
    },

    "& .column1, & .column2, & .column3": {
      flexBasis: "calc(1 / 3 * 100%)",
    },

    "& .column1": {
      borderRight: "2px solid #707070",
    },
    "& .column2": {
      borderRight: "2px solid #707070",
      color: "#329BC9",
    },
    "& .column3": {
      borderRight: "none",
    },

    [`@media (min-width: 2000px)`]: {
      marginTop: "2vh",
    },

    [`@media (max-width: 480px)`]: {
      paddingTop: "15px",
      flexDirection: "column",

      "& .column1, & .column2, & .column3": {
        flexBasis: "100%",
        borderRight: "none",
        marginBottom: "15px",
      },
    },
  },

  [`@media (min-width: 2000px)`]: {
    height: "auto",
  },
  [`@media ${props.theme.breakpoints.lg}`]: {
    height: "auto !important",

    "& .container": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      height: "auto",
    },
    "& .column1, .column2, .column3, .column4,.column5,.column6": {
      width: "100% !important",
      height: "auto !important",
    },
  },
}));
export const CMOffer = styled.div((props) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-around",
  paddingBottom: "5%",
  paddingTop: "7%",

  "& Button": {
    height: 53,
    width: 254,
    fontWeight: 500,
    fontFamily: props.theme.fontFamilies.jost,
    fontSize: 28,
    borderRadius: 30,
    [`@media (min-width: 2000px)`]: {
      fontSize: "3vh",
      width: "20vh",
      height: "5vh"
    },
  },
  "& .txtButtonStyle": {
    border: "none",
    textAlign: "left",
    fontWeight: 400,
    [`@media ${props.theme.breakpoints.lg}`]: {
      textAlign: "center"
    },
    [`@media ${props.theme.breakpoints.xs}`]: {
      textAlign: "center"
    },
  },

  [`@media (min-width: 2000px)`]: {
    paddingTop: "0%",
  },

  [`@media ${props.theme.breakpoints.lg}`]: {
    flexDirection: "column",
    alignItems: "center",
  },
  [`@media ${props.theme.breakpoints.xs}`]: {
    flexDirection: "column",
    alignItems: "center",
  },
}));
export const CMDisclaimer = styled.div((props) => ({
  width: "98%",
  overflow: "auto",
  maxHeight: "105px",
  marginBottom: "2%",
  marginTop: 17,
  "& p": {
    marginBottom: "1rem",
  },

  "&::-webkit-scrollbar": {
    width: "8px",
  },

  "&::-webkit-scrollbar-track": {
    backgroundColor: "white",
  },

  "&::-webkit-scrollbar-thumb": {
    borderRadius: "6px",
    backgroundColor: props.theme.palette.primary.main,
  },
  [`@media (min-width: 2000px)`]: {
    maxHeight: "100%",
  },
}));
export const CMDisBox = styled(Box)((props) => ({
  textAlign: "left",
  paddingTop: "55px",
  paddingLeft: "6%",
  "& h3": {
    [`@media (min-width: 2000px)`]: {
      fontSize: "3vh",
    },
  },
  "& p": {
    [`@media (min-width: 2000px)`]: {
      fontSize: "1.8vh",
    },
  }

}));
